export const moduleName = "postEditing";

export type PostEditingState = {
	editingPostId: string | null;
};
